/* eslint-disable no-unused-vars */
import {SubmitButton, ToggleSwitch} from "components/Button";
import {PatientDropdown} from "components/Dropdown";
import {DashboardLayout} from "components/Layout";
import Calendar from "components/DatePicker/Calendar";
import {Formik} from "formik";
import {useListPatient} from "hooks/AdminAdmission/Patient";
import {useDoctors} from "hooks/Doctor";
import {useAddAppoinment, useDetailAppointment, useEditAppoinment} from "hooks/Doctor/Appointment";
import {useToast} from "hooks/useToast";
import {useEffect, useMemo, useRef, useState} from "react";
import {Spinner} from "react-bootstrap";
import {useQueryClient} from "react-query";
import {useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import axios from "services/axios";
import {convertErrorMessageFormat, converToLocalGender, convertToCurency} from "utils/converter";
import {converISOtoDate, getDayName} from "utils/date";
import * as Yup from "yup";
import {usePaymentMethods} from "hooks/Misc/useQueryPaymentMethod";
import {useDoctorSchedules} from "hooks/Doctor";
import moment from "moment";
import {TimePicker} from "components/TimePicker";
import {ModalContainer} from "components/Modal";
import {Button, Form} from "react-bootstrap";
import {useDetailPasienBalance} from "hooks/PendaftaranPasien";
import {useListHargaAdministrasi} from "hooks/SuperAdmin/HargaAdministrasi";

const FormSchemaValidation = Yup.object().shape({
	idUserPatient: Yup.string().required("Pasien wajib di isi"),
	idUserDoctor: Yup.string().required("Dokter wajib di isi"),
	type: Yup.string().required("Tipe konsultasi wajib di isi"),
	startTime: Yup.string().required("Waktu mulai wajib di isi"),
	endTime: Yup.string().required("Waktu selesai wajib di isi"),
});
const FormInitialValues = {
	idUserPatient: "",
	idUserDoctor: "",
	type: "offline",
	startTime: "",
	endTime: "",
	useBalance: false,
};

export function AppointmentAddPage() {
	const {showToast} = useToast();
	const history = useHistory();
	const params = useParams();
	const {roleId} = useSelector(state => state.AuthReducer);

	const formikRef = useRef();
	const queryClient = useQueryClient();

	const [searchPatient, setSearchPatient] = useState("");
	const [searchDoctor, setSearchDoctor] = useState("");
	const [isQueue, setIsQueue] = useState(false);
	const toggleIsQueue = () => setIsQueue(!isQueue);

	const selectedHospital = useSelector(state => state.HospitalsReducer.selectedHospital);
	const {data: dataAdminPrice} = useListHargaAdministrasi({hospitalId: selectedHospital?.hospitalId});

	const appointmentId = params.id;

	const appointmentDetailQuery = useDetailAppointment(appointmentId);
	const appointmentDetail = appointmentDetailQuery.data?.data;

	const isEdit = !!appointmentDetail;

	useEffect(() => {
		if (!appointmentDetail) return;

		formikRef.current.setFieldValue("idUserPatient", appointmentDetail.idUserPatient + "");
		formikRef.current.setFieldValue("idUserDoctor", appointmentDetail.idUserDoctor + "");
		formikRef.current.setFieldValue("type", appointmentDetail.type);
		setSearchPatient(findRelatedId(appointmentDetail.idUserPatient.toString()));
		setSearchDoctor(findDoctorId(appointmentDetail.idUserDoctor.toString()));

		setTimeout(() => {
			formikRef.current.setFieldTouched("idUserPatient", true);
			formikRef.current.setFieldTouched("idUserDoctor", true);
			formikRef.current.setFieldTouched("type", true);
		});
	}, [appointmentDetail]);

	const [selectedDateTime, setSelectedDateTime] = useState({
		date: new Date(),
		time: null,
	});
	const [selectedEvent, setSelectedEvent] = useState();

	const {data: patients, isLoading: isFetchingPatients} = useListPatient({
		page: 1,
		search: null,
		limit: null,
		idHospital: selectedHospital?.hospitalId,
	});
	const patientOptions = useMemo(() => {
		if (!patients?.success) return [];

		return patients?.data?.rows?.map(patient => ({
			value: patient?.patient?.idUser + "",
			label: `${patient?.firstName} ${patient?.lastName} [${patient?.patient?.medicalRecordNumber}]`,
			desc: `${converToLocalGender(patient?.gender)} - ${patient?.email} - ${patient?.phoneNumber}`,
			image: patient?.profilePhoto,
		}));
	}, [patients]);

	const {data: doctors, isLoading: isFetchingDoctors} = useDoctors({
		limit: null,
		hospitalId: selectedHospital?.hospitalId,
	});
	const doctorOptions = useMemo(() => {
		if (!doctors?.success) return [];

		return doctors?.data?.rows?.map(doctor => ({
			value: doctor.id + "",
			label: `Dokter ${doctor.fullName} (${doctor?.staff?.policlinic?.name || "Dokter Umum"})`,
			desc: doctor?.staff?.policlinic?.name || "Dokter Umum",
			image: doctor?.profilePhoto,
		}));
	}, [doctors]);

	// const handleSelectDateTime = data => {
	// 	setSelectedDateTime({date: data.selectedDay, time: data.selectedTime});
	// };

	const addMutation = useAddAppoinment();
	const updateMutation = useEditAppoinment();

	const onSuccess = () => {
		showToast("success", `Data berhasil ${appointmentDetail ? "diperbarui" : "ditambahkan"}`, 3000);
		history.push("/admission/appointment/list");
	};

	// const [selectedTime, setSelectedTime] = useState("");
	// const {data: dataPaymentMethod} = usePaymentMethods();
	// const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();

	const handleQueue = async id => {
		await axios
			.get(`/v2/booking/${id}/queue`)
			.then(response => {
				const res = response.data;

				if (res.success && res.data !== null) {
					setIsQueue(false);
					onSuccess();
				} else if (!res.success) {
					setIsQueue(false);
					showToast(
						"error",
						`Gagal mengambil antrian: ${convertErrorMessageFormat(
							res?.response?.status,
							res?.response?.data?.message,
						)}`,
					);
				} else {
					setTimeout(() => {
						handleQueue(id);
					}, 3000);
				}
			})
			.catch(res => {
				setIsQueue(false);
				showToast(
					"error",
					`Gagal mengambil antrian: ${convertErrorMessageFormat(
						res?.response?.status,
						res?.response?.data?.message,
					)}`,
				);
				// history.push("/admission/appointment/list");
			})
			.finally(() => {
				queryClient.removeQueries("DOCTOR_SCHEDULES");
			});
	};

	const handleSubmit = formData => {
		const {date, time} = selectedDateTime;

		const payload = {
			id: appointmentDetail?.id || null,
			idUserPatient: parseInt(formData.idUserPatient),
			idUserDoctor: parseInt(formData.idUserDoctor),
			idHospital: selectedHospital.Hospital.id,
			date: moment(date).format("YYYY-MM-DD"),
			startTime: formData?.startTime,
			endTime: formData?.endTime,
			type: formData.type,
			price: dataAdminPrice?.data?.rows?.[0]?.price ?? 0, // time?.prices[0] ?? 0,
			otherIdentity: null,
			patientIdentity: null,
			requested_by_role_id: roleId,
			// paymentMethodId: selectedPaymentMethod,
			// useBalance: formData.useBalance,
		};

		// const detailPayemnt = dataPaymentMethod?.data?.find(item => item.id === selectedPaymentMethod);

		// if (detailPayemnt?.type === "CARD") {
		// 	payload.cardHolder = dataCC.holder;
		// 	payload.cardNumber = dataCC.number;
		// 	payload.cardExpiry = dataCC.expiry;
		// 	payload.cardCvv = dataCC.cvv;
		// }

		const onError = res => {
			showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
		};

		if (appointmentDetail) {
			updateMutation.mutate(payload, {
				onSuccess,
				onError,
			});
		} else {
			toggleIsQueue();

			addMutation.mutate(payload, {
				onSuccess: data => {
					handleQueue(data.data);
				},
				onError,
			});
		}
	};

	const findRelatedId = value => {
		return patientOptions.find(x => x.value === value)?.label || value;
	};

	const findDoctorId = value => {
		return doctorOptions.find(x => x.value === value)?.label || value;
	};

	const getRemainingDaysInMonth = (includeToday = false) => {
		const today = moment();
		const endOfMonth = moment().endOf("month");
		const diff = endOfMonth.diff(today, "days");

		return includeToday ? diff + 1 : diff;
	};

	const [currentPage, setCurrentPage] = useState(1);
	const {data: doctorDateSchedules, isLoading: fetchingSchedule} = useDoctorSchedules({
		// hospitalId: selectedLocation.hospitalId || undefined,
		userId: parseInt(formikRef?.current?.values?.idUserDoctor),
		type: formikRef?.current?.values?.type,
		page: currentPage,
		limit: currentPage > 1 ? 30 : getRemainingDaysInMonth(true),
	});
	const schedules = useMemo(() => {
		if (doctorDateSchedules?.data) {
			return doctorDateSchedules.data.map(item => {
				return {
					...item,
					id: item.day,
					originalDate: item.date,
				};
			});
		}

		return [];
	}, [doctorDateSchedules]);

	const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
	const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
	const handleChangeMonth = (month, year) => {
		if (month === currentMonth && year > currentYear) {
			setCurrentPage(currentPage + (year - currentYear) * 12);

			setCurrentMonth(month);
			setCurrentYear(year);

			return;
		} else if (month === currentMonth && year < currentYear) {
			setCurrentPage(currentPage - (currentYear - year) * 12);
			setCurrentMonth(month);
			setCurrentYear(year);

			return;
		}

		if (year >= currentYear && month > currentMonth) {
			setCurrentPage(currentPage + (currentMonth + month));
			setCurrentMonth(month);
			setCurrentYear(year);

			return;
		} else {
			setCurrentPage(currentPage - (currentMonth - month));
			setCurrentMonth(month);
			setCurrentYear(year);

			return;
		}
	};

	// useEffect(() => {

	// }, [selectedDateTime.date])

	// const [isOpenCC, setIsOpenCC] = useState(false);
	// const [dataCC, setDataCC] = useState({
	// 	holder: "",
	// 	number: "",
	// 	expiry: "",
	// 	cvv: "",
	// });

	// const {data: pasienBalance} = useDetailPasienBalance(formikRef?.current?.values?.idUserPatient);

	const handleStartTimeChange = time => {
		if (selectedEvent) {
			const eventTimes = selectedEvent.times.find(item => item.startTime === time);

			if (eventTimes) {
				formikRef.current.setFieldValue("endTime", eventTimes.endTime);
			}
		}
	};

	return (
		<DashboardLayout>
			{isQueue ? (
				<div
					className="d-flex align-items-center justify-content-center flex-column gap-3"
					style={{minHeight: "50vh"}}>
					<h1>Sedang mengambil antrian</h1>
					<Spinner />
				</div>
			) : (
				<Formik
					initialValues={FormInitialValues}
					innerRef={formikRef}
					validationSchema={FormSchemaValidation}
					onSubmit={handleSubmit}>
					{({
						handleSubmit,
						handleBlur,
						handleChange,
						setFieldValue,
						values,
						errors,
						setFieldTouched,
						touched,
					}) => (
						<div class="box-white setting-content h-100 no-border p24">
							<div class="d-flex justify-content-between flex-wrap align-items-center mb-4">
								<div class="ttl-20">{isEdit ? "Ubah" : "Tambah"} Appointment</div>
							</div>
							<hr />

							<div class="text-bold mb-4">
								<a
									class="text-dark"
									style={{cursor: "pointer"}}
									onClick={() => history.push("/admission/appointment/list")}>
									<span class="icon-ico-back me-2" />
								</a>
								Daftar List Appointment
							</div>

							<div class="row gx-4 mb-5">
								<div class="col-sm-12 col-lg-6  col-xs-12">
									<div class="setting-item">
										<PatientDropdown
											required
											data={patientOptions}
											disabled={!!isEdit}
											error={errors.idUserPatient}
											label="Pasien"
											loading={isFetchingPatients}
											name="idUserPatient"
											placeholder="Ketikan nama, email atau nomor handphone pasien.."
											searchKeyValue={["label", "desc"]}
											// value={values.idUserPatient}
											// value={findRelatedId(values.idUserPatient)}
											value={searchPatient}
											onBlur={handleBlur}
											onChange={selectedValue => {
												setFieldValue("idUserPatient", selectedValue.value);
												setSearchPatient(findRelatedId(selectedValue.value));
											}}
											onInput={e => {
												setSearchPatient(e);
											}}
										/>
									</div>
								</div>

								{/* <div class="col-sm-12 col-lg-6  col-xs-12">
								<div class="setting-item">
									<label class="setting-label required">Unit</label>
									<select
										className={clsx("form-control", errors?.unitId && "form-control-error")}
										disabled={isLoading}
										name="unitId"
										value={values?.unitId}
										onBlur={handleBlur}
										onChange={handleChange}>
										<option value="">Pilih Unit</option>
										{hospitalUnitOptions.map(option => (
											<option value={option.value}>{option.label}</option>
										))}
									</select>
									{errors.unitId && <p className="form-error-item-message">{errors.unitId}</p>}
								</div>
							</div> */}

								<div class="col-sm-12 col-lg-6  col-xs-12">
									<div class="setting-item">
										<label class="setting-label required">Tipe Konsultasi</label>
										<div className="d-flex">
											<div className="me-4">
												<label>
													<input
														checked={values.type === "offline"}
														className="me-2"
														name="type"
														type="radio"
														// checked
														value="offline"
														onBlur={handleBlur}
														onChange={handleChange}
													/>
													Offline
												</label>
											</div>
											{/* <div>
												<label>
													<input
														checked={values.type === "online"}
														className="me-2"
														name="type"
														type="radio"
														value="online"
														onBlur={handleBlur}
														onChange={handleChange}
													/>
													Telekonsul/Online
												</label>
											</div> */}
										</div>
									</div>
								</div>

								<div class="col-sm-12 col-lg-6  col-xs-12">
									<div class="setting-item">
										<PatientDropdown
											required
											data={doctorOptions}
											error={errors.idUserDoctor}
											label="Dokter"
											loading={isFetchingDoctors}
											name="idUserDoctor"
											placeholder="Ketikan nama dokter..."
											searchKeyValue={["label", "desc"]}
											// value={values.idUserDoctor}
											value={searchDoctor}
											// value={findDoctorId(values.idUserDoctor)}
											onBlur={handleBlur}
											onChange={selectedValue => {
												setFieldValue("idUserDoctor", selectedValue.value);
												setSearchDoctor(findDoctorId(selectedValue.value));
											}}
											onInput={e => {
												setSearchDoctor(e);
											}}
										/>
									</div>
								</div>

								{appointmentDetail && (
									<div class="col-sm-12 col-lg-6  col-xs-12">
										<div class="setting-item">
											<div>
												<span className="fw-bold">Jadwal Terpilih</span>
												<p>
													{`${getDayName(appointmentDetail.date, "ID-id")}, ${converISOtoDate(
														appointmentDetail.date,
													)}`}{" "}
													<br />
													{`${appointmentDetail.startTime} - ${appointmentDetail.endTime}`}{" "}
													WIB
												</p>
											</div>
										</div>
									</div>
								)}

								<div class="col-12 mt-4">
									{values.idUserDoctor && (
										<div class="row">
											<div class="col-6">
												{/* <ScheduleSelect
													doctorId={parseInt(values.idUserDoctor)}
													hospitalId={selectedHospital?.Hospital?.id}
													type={values.type}
													onSelectDateTime={handleSelectDateTime}
												/> */}

												<div className="text-bold mb-4 ft-16">Pilih Hari</div>
												<Calendar
													events={schedules}
													handleChangeMonth={handleChangeMonth}
													selectedDate={selectedDateTime.date}
													onChangeDate={(date, event) => {
														setSelectedEvent(event);
														setSelectedDateTime(prev => ({...prev, date}));
													}}
												/>

												<div className="text-bold mb-2 mt-5 ft-16">Pilih Jam</div>
												<div className="row gx-2">
													<div className="col-sm-6 mb-2">
														<div className="ft-12 text-light-grey mb-2">Jam Mulai</div>
														<div className="position-relative">
															<TimePicker
																styleTopIcon={25}
																value={values.startTime}
																onChange={fieldValue => {
																	setFieldTouched("startTime", true);
																	setFieldValue(
																		"startTime",
																		fieldValue?.format("HH:mm"),
																	);
																	handleStartTimeChange(fieldValue?.format("HH:mm"));
																}}
															/>
															{errors?.startTime && touched?.startTime && (
																<p className="form-error-item-message">
																	{errors?.startTime}
																</p>
															)}
														</div>
													</div>
													<div className="col-sm-6 mb-2">
														<div className="ft-12 text-light-grey mb-2">Jam Selesai</div>
														<div className="position-relative">
															<TimePicker
																styleTopIcon={25}
																value={values?.endTime}
																onChange={fieldValue => {
																	setFieldTouched("endTime", true);
																	setFieldValue(
																		"endTime",
																		fieldValue?.format("HH:mm"),
																	);
																}}
															/>
														</div>
														{errors?.endTime && touched?.endTime && (
															<p className="form-error-item-message">{errors?.endTime}</p>
														)}
													</div>
												</div>
											</div>
										</div>
									)}
								</div>
								{/* <div className="col-12 mt-4">
									<span className="fw-bold">Metode Pembayaran</span>
									<div className="d-flex align-items-center gap-3 mb-3 mt-3">
										<p className="mb-0">
											Jumlah Saldo Pasien:{" "}
											<span className="fw-bold">
												Rp. {convertToCurency(String(pasienBalance?.data?.amount || 0))}
											</span>
										</p>
										<Form.Check
											checked={values.useBalance}
											disabled={!pasienBalance?.data?.amount}
											type="switch"
											onChange={e => {
												setFieldValue("useBalance", e.target.checked);
												if (e.target.checked) {
													setSelectedPaymentMethod(null);
												}
											}}
										/>
									</div>
									<p className="mb-0">
										Sisa yang harus dibayarkan:{" "}
										<span className="fw-bold">
											Rp.{" "}
											{convertToCurency(
												String(
													formikRef?.current?.values?.useBalance
														? (dataAdminPrice?.data?.rows?.[0]?.price || 0) -
																(pasienBalance?.data?.amount || 0)
														: dataAdminPrice?.data?.rows?.[0]?.price || 0,
												),
											)}
										</span>
									</p>
									<div className="row gap-4">
										{dataPaymentMethod?.data?.map(item => (
											<div
												key={item.id}
												className="col-3 g-4 border border-light-subtle py-2 rounded-3 d-flex gap-4 align-items-center"
												style={{
													cursor: "pointer",
													backgroundColor: selectedPaymentMethod === item.id && "#D3D3D3",
												}}
												onClick={() => {
													setSelectedPaymentMethod(item.id);
													if (item.type === "CARD") {
														setIsOpenCC(true);
													}
												}}>
												<img alt={item.name} src={item.logo} width={100} />
												<span>{item.name}</span>
											</div>
										))}
									</div>
								</div>
								<ModalContainer visible={isOpenCC}>
									<div className="d-flex flex-column bg-white px-5 pt-2 pb-5 rounded-2">
										<div className="p-4">
											<div className="text-bold mb-3">Masukan Kartu Kredit</div>
											<div className="mb-3">
												<label className="form-label">Nama Pada Kartu</label>
												<input
													className="form-control"
													placeholder="Masukan nama pada kartu kredit"
													type="text"
													onChange={e => setDataCC({...dataCC, holder: e.target.value})}
												/>
											</div>
											<div className="mb-3">
												<label className="form-label">Nomor Kartu</label>
												<input
													className="form-control"
													placeholder="Masukan nomor kartu kredit"
													type="text"
													onChange={e => setDataCC({...dataCC, number: e.target.value})}
												/>
											</div>
											<div className="mb-3">
												<label className="form-label">Tanggal Kadaluarsa</label>
												<input
													className="form-control"
													placeholder="MM/YY"
													type="text"
													onChange={e => setDataCC({...dataCC, expiry: e.target.value})}
												/>
											</div>
											<div className="mb-3">
												<label className="form-label">CVV</label>
												<input
													className="form-control"
													placeholder="Masukan CVV"
													type="text"
													onChange={e => setDataCC({...dataCC, cvv: e.target.value})}
												/>
											</div>
										</div>
										<div className="text-center">
											<Button
												className="d-inline-block btn-green mw-250 me-2"
												onClick={() => setIsOpenCC(false)}>
												Batal
											</Button>
											<SubmitButton
												className="btn btn-orange d-inline-block mw-250"
												loading={false}
												text="Simpan Kartu"
												onClick={() => setIsOpenCC(false)}
											/>
										</div>
									</div>
								</ModalContainer> */}
							</div>

							<div class="text-center my-3">
								<SubmitButton
									className="btn btn-orange d-inline-block mw-250"
									disabled={
										!FormSchemaValidation.isValidSync(values) || selectedDateTime.date === null
									}
									loading={addMutation.isLoading}
									text="Simpan"
									onClick={handleSubmit}
								/>
							</div>
						</div>
					)}
				</Formik>
			)}
		</DashboardLayout>
	);
}
